import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import YourJourneyToBalanceStartsHere from "./sections/YourJourneyToBalanceStartsHere";
import ASafeSpaceForEveryVoice from "./sections/ASafeSpaceForEveryVoice";
import SpecializedPathsToHealing from "./sections/SpecializedPathsToHealing";
import WhyPrioritizeYourWellBeing from "./sections/WhyPrioritizeYourWellBeing";
import FlexibleCareForYourLife from "./sections/FlexibleCareForYourLife";
import TakeTheNextStepTogether from "./sections/TakeTheNextStepTogether";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <YourJourneyToBalanceStartsHere />
      <ASafeSpaceForEveryVoice />
      <SpecializedPathsToHealing />
      <WhyPrioritizeYourWellBeing />
      <FlexibleCareForYourLife />
      <TakeTheNextStepTogether />
      <FooterInformation />
    </div>;
}